import './profile.css'

import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Grid,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Spin,
  Tabs,
  Upload,
  message,
} from "antd";
import { EditOutlined, LockOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { api, api_url } from "../../services/api";
import { cities, states } from "estados-cidades";
import { getProfileLocal, isValidCPF } from "../../utils/common";

import AppLayout from "../../components/Layout";
import { ProCard } from "@ant-design/pro-components";
import ResponsibleField from "./Responsibles";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const rules = {
  nome: [{ required: false, message: "Insira o nome" }],
  cep: [{ required: false, message: "Insira um cep" }],
  endereco: [{ required: false, message: "Insira um endereço" }],
  bairro: [{ required: false, message: "Insira um bairro" }],
  uf: [{ required: false, message: "Insira uma unidade federal" }],
  cidade: [{ required: false, message: "Insira uma cidade" }],
  email: [{ required: false, message: "Insira um telefone" }],
};


const { useBreakpoint } = Grid;
const onPreview = async (file) => {
  let src = file.url;
  if (!src) {
    src = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
    });
  }
  const image = new Image();
  image.src = src;
  const imgWindow = window.open(src);
  imgWindow.document.write(image.outerHTML);
};

export default function MyAccount() {
  const breakpoint = useBreakpoint();
  const [loading, setLoading] = useState(false);
  const [uf, setUf] = useState("RJ");
  const [user, setUser] = useState([]);
  const [passwordChange, setPasswordChange] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [rne, setRne] = useState(false);
  const isStudent = getProfileLocal()?.role_id === 5

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const formattedCPF = (value) => {
    let formattedValue;

    if (value)
      formattedValue = value
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1-$2");

    return formattedValue;
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("Você só pode enviar arquivos JPG/PNG!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("A imagem deve ser menor que 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  function cepValidation(value) {
    //Nova variável "cep" somente com dígitos.
    var cep = value?.replace(/\D/g, "");
    if (cep !== "") {
      //Expressão regular para validar o CEP.
      var validacep = /^[0-9]{8}$/;

      //Valida o formato do CEP.
      if (validacep.test(cep)) {
        return true;
      }
      return false;
    }

    return false;
  }

  async function cepIsValid(value) {
    let formattedValue = value
      ?.replace(/\D/g, "")
      ?.replace(/(\d{5})(\d)/, "$1-$2");

    form.setFieldsValue({
      cep: formattedValue,
    });

    if (cepValidation(value)) {
      const { data } = await api.get(
        `/api/misc/cep/${value.replaceAll("-", "").replaceAll(".", "")}`
      );

      form.setFieldsValue({
        street: data.logradouro,
        neighborhood: data.bairro,
        city: data.localidade,
        state: data.uf,
      });
    }

    return formattedValue;
  }

  const ufChange = (UF) => {
    setUf(UF);
    form.setFieldsValue({
      city: "",
    });
  };

  const formattedTell = (value) => {
    let formattedValue;

    if (value) {
      if (value.length < 15) {
        formattedValue = value
          ?.replace(/\D/g, "")
          ?.replace(/(\d{0})(\d)/, "$1($2")
          ?.replace(/(\d{2})(\d)/, "$1) $2")
          ?.replace(/(\d{4})(\d)/, "$1-$2");
      } else {
        formattedValue = value
          ?.replace(/\D/g, "")
          ?.replace(/(\d{0})(\d)/, "$1($2")
          ?.replace(/(\d{2})(\d)/, "$1) $2")
          ?.replace(/(\d{5})(\d)/, "$1-$2");
      }
    }

    return formattedValue;
  };

  const rgIsValid = (value) => {
    let formattedValue;

    if (value) {
      formattedValue = value
        .replace(/\D+/g, "")
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1-$2");

      form.setFieldsValue({
        rg: formattedValue,
      });
    }

    return formattedValue;
  };

  const getUser = async () => {
    setLoading(true);
    try {
      const { data: res } = await api.get(`/panel/profile`);
      setUser(res.data);
    } catch (error) {
      error.message && message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUser();

    let academicResponsibles = {};

    if (!!user?.academic_responsibles) {
      for (let key in user?.academic_responsibles) {
        academicResponsibles[key.replace("academic_responsibles_", "")] =
          user?.academic_responsibles[key];
      }
    }

    if (
      user?.academic_responsibles?.length === 0 ||
      !user?.academic_responsibles
    ) {
      form.setFieldsValue({
        academic_responsibles: [
          {
            academic_responsibles_name: " ",
          },
        ],
      });
    }
  }, []);

  useEffect(() => {
    cepIsValid(user?.cep);

    form.setFieldsValue({
      ...user,
      name: user?.name || "",
      cpf: user?.cpf || "",
      profession: user?.profession || "",
      rg: user?.rg || "",
      city: user?.city || "",
      marital_status: user?.marital_status || "",
      schooling: user?.schooling || "",
      school: user?.school || "",
      complement: user?.complement || "",
      mobile: formattedTell(user?.mobile) || "",
      neighborhood: user?.neighborhood || "",
      phone: formattedTell(user?.phone) || "",
      number: user?.number || "",
      state: user?.state || "",
      street: user?.street || "",
      birthdate: moment(user?.birthdate),
      profile_name: user?.profiles ? user?.profiles[0] : "N/A",
    });

    const url = user?.profile_pic
      ? `${api_url}/upload/${user?.profile_pic}`
      : "https://via.placeholder.com/80x80";
    setFileList([
      {
        uid: "-1",
        name: "logo",
        status: "done",
        url,
      },
    ]);
  }, [user, form]);

  const onFinish = async () => {
    setLoading(true);

    form
      .validateFields()
      .then(async (values) => {
        try {
          const financial_responsible = {
            name: values?.financial_responsible_name,
            cpf: values?.financial_responsible_cpf?.replace(/\D/g, ""),
            mobile: values?.financial_responsible_mobile?.replace(/\D/g, ""),
            email: values?.financial_responsible_email,
            cep: values?.financial_responsible_cep?.replace(/\D/g, ""),
            rg: values?.financial_responsible_rg,
            commercial_phone:
              values?.financial_responsible_commercial_phone?.replace(
                /\D/g,
                ""
              ),
            phone: values?.financial_responsible_phone?.replace(/\D/g, ""),
            street: values?.financial_responsible_street,
            state: values?.financial_responsible_state,
            number: values?.financial_responsible_number,
            complement: values?.financial_responsible_complement,
            neighborhood: values?.financial_responsible_neighborhood,
            city: values?.financial_responsible_city,
          };

          const academic_responsibles = values?.academic_responsibles?.map(
            (el) => {
              let newEl = {};
              for (let key in el) {
                newEl[key?.replace("academic_responsibles_", "")] = el[key];
              }

              return {
                ...newEl,
                cpf: el.academic_responsibles_cpf?.replace(/\D/g, ""),
                email: el.academic_responsibles_email,
                commercial_phone:
                  el.academic_responsibles_commercial_phone?.replace(/\D/g, ""),
                name: el.academic_responsibles_name,
              };
            }
          );

          delete values.academic_responsibles;

          const data = new FormData();
          data.append("_method", "PUT");
          if (values?.profile_pic?.file?.status === "removed") {
            data.append("delete_profile_pic", 1);
            delete values.profile_pic;
          }
          if (academic_responsibles && !isStudent)
            academic_responsibles.forEach((item, index) => {
              Object.keys(item).forEach((key) => {
                if (item[key] !== null && typeof item[key] !== "undefined")
                  data.append(
                    `academic_responsibles[${index}][${key}]`,
                    item[key]
                  );
              });
            });

          if (financial_responsible && !isStudent)
            Object.keys(financial_responsible).forEach((key) => {
              if (
                financial_responsible[key] !== null &&
                typeof financial_responsible[key] !== "undefined"
              )
                data.append(
                  `financial_responsible[${key}]`,
                  financial_responsible[key]
                );
            });

          Object.keys(values).forEach((item) => {
            if (values[item] !== null && typeof values[item] !== "undefined") {
              values.profile_pic = values?.profile_pic?.file;
              data.append(item, values[item]);
            }
          });

          const { data: response } = await api.post("/panel/profile", data, {
            withCredentials: true,
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
            headers: {
              "Content-type": "multipart/form-data; boundary=--XXRFXXX",
            },
          });
          message.success(response.message);
          navigate("/");
        } catch (error) {
          error.message && message.error(error.message);
        }
      })
      .catch((error) => {
        console.log(error);
        message.error("Preencha os campos corretamente");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        size="large"
        style={{ padding: "10px 20px" }}
      >
        <Tabs defaultActiveKey="1" style={{ height: "100%" }}>
          <Tabs.TabPane
            tab="Dados Gerais"
            key="1"
            children={
              <Spin
                spinning={loading}
              >
                <ProCard title="Dados Gerais">
                  <Row gutter={[24, 16]}>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={8}
                      order={breakpoint.md ? 1 : 2}
                    >
                      <Form.Item name="name" label="Nome" rules={rules.nome}>
                        <Input placeholder="Nome" />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={8}
                      order={breakpoint.md ? 2 : 3}
                    >
                      <Form.Item label="Perfil" name={"profile_name"}>
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={8}
                      lg={8}
                      order={breakpoint.md ? 3 : -1}
                      style={{
                        display: 'flex',
                        flexDirection: !breakpoint.md
                          ? "column-reverse"
                          : "column",
                        alignItems: !breakpoint.md ? "center" : "flex-start",
                      }}
                    >
                      <span style={{ fontWeight: 700 }}>Foto</span>
                      <Form.Item name="profile_pic">
                        {/* <ImgCrop
                    rotate
                    className="w-100"
                    modalTitle="Edite sua imagem"
                    modalCancel="Cancelar"
                    modalOk="Salvar"
                  > */}
                        <Upload
                          listType="picture-card"
                          fileList={fileList}
                          onChange={onChange}
                          onPreview={onPreview}
                          className="avatar-uploader upload-custom"
                          beforeUpload={() => false}
                        >
                          {fileList.length < 1 && "+ Upload"}
                        </Upload>
                        {/* </ImgCrop> */}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} lg={8} order={4}>
                      <Form.Item label="Profissão" name={"profession"}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} lg={8} order={5}>
                      <Form.Item label="Data de nascimento" name={"birthdate"}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          style={{ width: "100%" }}
                          placeholder="Data de nascimento"
                          disabledDate={(current) =>
                            current && current > moment().endOf("day")
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} lg={8} order={6}>
                      <Form.Item label="Estado Civil" name={"marital_status"}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} lg={8} order={7}>
                      <Form.Item name="sex" label="Sexo">
                        <Radio.Group>
                          <Radio value={"M"}>Masculino</Radio>
                          <Radio value={"NB"}>Não-Binário</Radio>
                          <Radio value={"F"}>Feminino</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} lg={8} order={8}>
                      <Form.Item label="Escolaridade" name={"schooling"}>
                        <Input />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} lg={8} order={9}>
                      <Form.Item label="Escola" name={"school"}>
                        <Input />
                      </Form.Item>
                    </Col>
                    {!rne ? (
                      <>
                        <Col xs={24} sm={12} lg={8} order={11}>
                          <Form.Item
                            name="rg"
                            label="R.G."
                            rules={[
                              { required: false, message: "Insira o R.G." },
                            ]}
                          >
                            <Input
                              placeholder="00.000.000-0"
                              maxLength={15}
                              minLength={11}
                              onChange={(e) => rgIsValid(e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} lg={8} order={12}>
                          <Form.Item
                            name="cpf"
                            label="CPF"
                            rules={[
                              { required: false, message: "Insira o CPF" },
                              {
                                validator: async (_, value) => {
                                  formattedCPF(value);

                                  if (
                                    value?.length >= 14 &&
                                    !isValidCPF(value)
                                  ) {
                                    return Promise.reject(
                                      new Error("CPF invalido")
                                    );
                                  }

                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Input
                              placeholder="00.000.000-00"
                              minLength={10}
                              maxLength={14}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    ) : (
                      <Col xs={24} sm={12} lg={8} order={10}>
                        <Form.Item
                          name="rne"
                          label="Registro Nacional do Estrangeiro"
                        >
                          <Input placeholder="0000.0000.000.0" />
                        </Form.Item>
                      </Col>
                    )}

                    <Col sm={!rne ? 24 : 12} lg={8} order={9}>
                      <Form.Item label="RNE">
                        <Checkbox onChange={() => setRne(!rne)}>
                          Aluno estrangeiro
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                </ProCard>

                <ProCard title="Endereço">
                  <Row gutter={[24, 16]}>
                    <Col xs={24} sm={12} lg={6}>
                      <Form.Item name="cep" label="CEP">
                        <Input
                          placeholder="CEP"
                          onChange={(e) => cepIsValid(e.target.value)}
                          maxLength={9}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={6}>
                      <Form.Item name="state" label="UF">
                        <Select
                          className="w-100"
                          placeholder="Estado"
                          defaultValue="RJ"
                          onChange={ufChange}
                        >
                          {states().map((state) => (
                            <Select.Option key={state}>{state}</Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} lg={6}>
                      <Form.Item name="city" label="Cidade">
                        <Select placeholder="Cidades">
                          {cities(uf)?.map((item) => (
                            <Select.Option key={item} value={item}>
                              {item}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} lg={6}>
                      <Form.Item name="neighborhood" label="Bairro">
                        <Input placeholder="Bairro" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} lg={6}>
                      <Form.Item name="street" label={"Rua"}>
                        <Input placeholder={"Rua"} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} lg={6}>
                      <Form.Item name="number" label="Número">
                        <InputNumber placeholder="Número" />
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item name="complement" label="Complemento">
                        <Input.TextArea rows={4} />
                      </Form.Item>
                    </Col>
                  </Row>
                </ProCard>

                <ProCard title="Comunicação" className="w-100">
                  <Row gutter={[24, 16]}>
                    <Col xs={24} sm={12} lg={8}>
                      <Form.Item name="phone" label="Telefone">
                        <Input
                          placeholder="Telefone"
                          type="tel"
                          onChange={(e) => {
                            form.setFieldsValue({
                              phone: formattedTell(e.target.value),
                            });
                          }}
                          maxLength={15}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} lg={8}>
                      <Form.Item name="mobile" label="Celular">
                        <Input
                          placeholder="Celular"
                          type="tel"
                          maxLength={15}
                          onChange={(e) => {
                            form.setFieldsValue({
                              mobile: formattedTell(e.target.value),
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} lg={8}>
                      <Form.Item label="Email">
                        <Input value={user.email} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Button
                    icon={<EditOutlined />}
                    style={{ marginBottom: "20px", marginLeft: "10px" }}
                    onClick={() => setPasswordChange(!passwordChange)}
                  >
                    Editar Senha
                  </Button>
                  {passwordChange && (
                    <>
                      <Row gutter={[24, 16]}>
                        <Col md={6}>
                          <Form.Item name="old_password" label="Senha atual">
                            <Input.Password
                              autoComplete="off"
                              prefix={
                                <LockOutlined
                                  className="text-primary"
                                  autoComplete="off"
                                />
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col md={6}>
                          <Form.Item name="password" label="Nova senha">
                            <Input.Password
                              minLength={8}
                              prefix={
                                <LockOutlined
                                  className="text-primary"
                                  autoComplete="off"
                                />
                              }
                            />
                          </Form.Item>
                        </Col>

                        <Col md={6}>
                          <Form.Item
                            name="password_confirmation"
                            label="Confirme a nova senha"
                          >
                            <Input.Password
                              minLength={8}
                              prefix={
                                <LockOutlined
                                  className="text-primary"
                                  autoComplete="off"
                                />
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
                </ProCard>
              </Spin>
            }
          />
          <Tabs.TabPane
            tab="Responsáveis"
            key="2"
            children={<ResponsibleField user={user} form={form} />}
          />
        </Tabs>

        <Button
          type="primary"
          htmlType="submit"
          style={{
            float: "right",
            marginTop: "20px",
          }}
          loading={loading}
        >
          Salvar
        </Button>
      </Form>
    </>
  );
}
